import { render, staticRenderFns } from "./ListOrdersCertifie.vue?vue&type=template&id=774d0d84&"
import script from "./ListOrdersCertifie.vue?vue&type=script&lang=js&"
export * from "./ListOrdersCertifie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports